
import CryptoJS from 'crypto-js';
import { APP_CONFIG } from '../global/Constants';

export class CryptoService {

    static encryptData(key, data) {
        try {
            return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
        } catch (e) {

        }
    }

    static decryptData(key, data) {
        try {
            const bytes = CryptoJS.AES.decrypt(data, key);
            if (bytes.toString()) {
                return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            }
            return data;
        } catch (e) {

        }
    }

    static encryptPassword(password) {
        try {
            return CryptoJS.AES.encrypt(password, APP_CONFIG.USER_KEY).toString();
        } catch (e) {

        }
    }
}